// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vx-routes__created{display:flex;justify-content:space-evenly}.vx-routes__created .vx-explore-card__details{border:1px solid #eaeaea;border-top:none;border-radius:0 0 6px 6px}.vx-routes__empty{display:flex;align-items:center;flex-wrap:wrap}\n", ""]);
// Exports
module.exports = exports;
